// extracted by mini-css-extract-plugin
module.exports = {"container":"ArtistInvite_container__UpTG1","input":"ArtistInvite_input__cuz6u","submit":"ArtistInvite_submit__71Bhq","wallet":"ArtistInvite_wallet__UfaBX"};